export default __webpack_public_path__ + "static/media/r7.f1807e66.jpeg";